import { render, staticRenderFns } from "./relax.vue?vue&type=template&id=10585e9f&scoped=true&"
import script from "./relax.vue?vue&type=script&lang=js&"
export * from "./relax.vue?vue&type=script&lang=js&"
import style0 from "./relax.vue?vue&type=style&index=0&id=10585e9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10585e9f",
  null
  
)

export default component.exports